import React, { Suspense, lazy, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { authContext } from "../../data/authContext";
import { Link } from 'react-router-dom';
import PopupLogout from '../../views/pop-up/pop-up-logout';
import { GET_PARENT } from '../../common';
import { ICON_USER_PROFILE_IMG } from '../../common/images-s3';

const AUTH0_CLAIM_URL = "http://ngs.flex-solver.app/claim/";
const ImageLoader = lazy(() => import('../../common/image-loader'));


export const Login = () => {
    const [showHideLogoutPopup, setshowHideLogoutPopup] = useState(false);
    const { loginWithRedirect, loginWithPopup, logout, isAuthenticated, user, isLoading } = useAuth0();
    let context = authContext;
    var firstName = '';
    var lastName = '';
    let userName = '';
    var guid = '';

    if (isLoading) {
        return <span>{/* Loading ... */}</span>
    }

    if (user) {
        const entries = Object.entries(user);
        entries.map(res => {
            if (res[0] === AUTH0_CLAIM_URL + 'firstname') {
                firstName = res[1]
            } else if (res[0] === AUTH0_CLAIM_URL + 'lastname') {
                lastName = res[1]
            }
        })

        userName = user?.name === user?.email ? (firstName + " " + lastName) : user?.name;
        guid = user.sub.split('|')[1];

        context.isUserLoggedIn = isAuthenticated;
        context.userEmail = user?.email;
        context.userName = userName;
        context.guid = guid;
        localStorage.setItem("isAuthenticated", isAuthenticated);
        localStorage.setItem("user_guid", context.guid);
    }

    const closePopup = (e) => {
        e.preventDefault();
        setshowHideLogoutPopup(false);
    }

    const onClickLogout = () => {
        localStorage.setItem("isAuthenticated", false);
        localStorage.removeItem("user_guid");
        logout({ returnTo: window.location.origin });
        //setshowHideLogoutPopup(false);
    }

    const navLinkClick = (e) => {
        let target = document.querySelector('button.navbar-toggler');
        let display = target?.currentStyle?.display || window?.getComputedStyle(target)?.display;

        if (display !== '' && display !== undefined && display !== 'none') {
            target.click();
        }
    }

    return (
        <>
            {
                isAuthenticated ?
                    <>
                        <div className="c-btn">
                            <div className="c-img-name">
                                <div className="c-img">
                                    <Suspense fallback={null}>
                                        <ImageLoader type="image" src={ICON_USER_PROFILE_IMG}></ImageLoader>
                                    </Suspense>
                                </div>
                                <Link to="/profile" className="user-name" onClick={navLinkClick}><span>{userName}</span></Link>
                                {/* <button type="button" className="btn btn-light logged-in-options">
                                     <Suspense fallback={null}>
                                         <ImageLoader type="image" src="/images/arrow-up-down.svg"></ImageLoader>
                                     </Suspense>
                                 </button> */}
                            </div>
                            <button type="button" className="btn btn-light btn-logout" onClick={() => {
                                setshowHideLogoutPopup(true);
                            }}>Logout</button>
                        </div>
                        {showHideLogoutPopup && <PopupLogout closeLogoutPopup={closePopup} logoutUser={onClickLogout}></PopupLogout>}
                    </>
                    :
                    <div className="c-btn">
                        <button type="button" className="btn btn-dark w-100 h-45" onClick={() => loginWithRedirect()}>Sign In</button>
                        {/* <button type="button" className="btn btn-dark w-100 h-45" onClick={() => loginWithPopup()}>Sign Up</button> */}
                    </div>
            }
        </>
    )
}